import Layout from "@/components/layout/Layout";
import PageHeader from "@/components/layout/PageHeader";
import Seo from "@/components/Seo";
import { LEGAL_LAST_UPDATED } from "@/data/legalData";

const Block = ({ item }) => {
  if (Array.isArray(item)) {
    return (
      <ul className="list-disc pl-6 space-y-2 text-slate-600">
        {item.map((li, i) => (
          <li key={i}>{li}</li>
        ))}
      </ul>
    );
  }
  if (item.table) {
    return (
      <>
      <p className="md:hidden text-xs text-slate-400">Плъзнете таблицата настрани, за да видите всички колони →</p>
      <div className="overflow-x-auto rounded-xl border border-slate-200">
        <table className="w-full text-sm text-left">
          <thead className="bg-slate-50 text-slate-700">
            <tr>
              {["Бисквитка", "Доставчик", "Цел", "Срок"].map((h) => (
                <th key={h} className="px-4 py-3 font-semibold">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {item.table.map((row) => (
              <tr key={row[0]} className="border-t border-slate-200 text-slate-600">
                {row.map((cell, i) => (
                  <td key={i} className={`px-4 py-3 align-top ${i === 0 ? "font-mono text-xs text-slate-800" : ""}`}>{cell}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      </>
    );
  }
  return <p className="text-slate-600 leading-relaxed">{item}</p>;
};

const LegalPage = ({ testId, title, subtitle, path, intro, sections }) => (
  <Layout>
    <Seo path={path} />
    <PageHeader subtitle={subtitle} title={title} />
    <section className="section-padding bg-white" data-testid={testId}>
      <div className="max-w-6xl mx-auto px-4 md:px-8 grid grid-cols-1 lg:grid-cols-[260px_1fr] gap-12">
        <aside className="lg:sticky lg:top-28 self-start bg-slate-50 rounded-2xl p-6" data-testid="legal-toc">
          <p className="font-semibold text-[#2E4A91] mb-4">Съдържание</p>
          <ol className="space-y-2 text-sm">
            {sections.map((s, i) => (
              <li key={s.id}>
                <a href={`#${s.id}`} className="text-slate-600 hover:text-[#2E4A91] transition-colors">
                  {i + 1}. {s.title}
                </a>
              </li>
            ))}
          </ol>
        </aside>
        <article className="space-y-10 min-w-0">
          <div className="space-y-3">
            <p className="text-sm text-slate-500" data-testid="legal-last-updated">
              Последна актуализация: {LEGAL_LAST_UPDATED}
            </p>
            {intro.map((p, i) => (
              <p key={i} className="text-slate-700 leading-relaxed">{p}</p>
            ))}
          </div>
          {sections.map((s, i) => (
            <div key={s.id} id={s.id} className="scroll-mt-28 space-y-4">
              <h2 className="text-xl md:text-2xl font-bold text-[#2E4A91]">
                {i + 1}. {s.title}
              </h2>
              {s.content.map((item, j) => (
                <Block key={j} item={item} />
              ))}
            </div>
          ))}
        </article>
      </div>
    </section>
  </Layout>
);

export default LegalPage;
